import { PageController } from '@client/components/_core/layout/PageController';
import { TimelineMilestonesSetting } from '@client/components/_core/settings/timeline/TimelineMilestonesSetting';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general/timeline')({
    staticData: {
        metadata: {
            title: 'Timeline',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: IncidentTimeline,
});

function IncidentTimeline() {
    const orgId = useOrgId();
    const navigate = useNavigate();

    return (
        <PageController route={Route}>
            <Outlet />
            <TimelineMilestonesSetting
                entity="incident"
                newMilestoneAction={
                    <Button.Add.Link
                        to="/console/$orgId/configuration/compliance/incidents/general/timeline/milestones/add"
                        params={{ orgId }}
                        variant="tertiary"
                        size="small"
                        label="New milestone"
                    />
                }
                onEdit={(internalName) =>
                    navigate({
                        to: '/console/$orgId/configuration/compliance/incidents/general/timeline/milestones/edit/$internalName',
                        params: { orgId, internalName },
                    })
                }
            />
        </PageController>
    );
}
